<template>
  <px-autocomplete-centro-custo-multiple
    dense
    v-bind="$attrs"
    @blur="onBlur"
    class="rounded-tag-small required"
    v-model="localValue"/>
</template>

<script>
export default {
  props: {
    value: Array,
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  methods: {
    onBlur(event) {
      this.$emit('blur', event);
    },
  },
};
</script>
